import axios from "axios";

export const createProduct = async (product, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/product`, product, {
    headers: {
      authtoken,
    },
  });

export const getProductsByCount = async (count) =>
  await axios.get(`${process.env.REACT_APP_API}/products/${count}`);

export const getStoreAllProductsByCount = async (count, store, delivery) =>
  await axios.get(`${process.env.REACT_APP_API}/products/${count}?store=${store}&&delivery=${delivery}`);

export const getProductsByCountAsc = async (count) =>
  await axios.get(`${process.env.REACT_APP_API}/productss/${count}`);

export const removeProduct = async (slug, authtoken) =>
  await axios.delete(`${process.env.REACT_APP_API}/product/${slug}`, {
    headers: {
      authtoken,
    },
  });

export const getProduct = async (slug, vare) =>
  await axios.get(`${process.env.REACT_APP_API}/product/${slug}?type=${vare}`);

export const updateProduct = async (slug, product, authtoken) =>
  await axios.put(`${process.env.REACT_APP_API}/product/${slug}`, product, {
    headers: {
      authtoken,
    },
  });

export const getProducts = async (sort, order, page) =>
  await axios.post(`${process.env.REACT_APP_API}/products`, {
    sort,
    order,
    page,
  });

export const getBestProducts = async (sort, order, page) =>
  await axios.post(`${process.env.REACT_APP_API}/best-products`, {
    sort,
    order,
    page
  });

export const getBestProductsFilter = async (sort, order, page) =>
  await axios.post(`${process.env.REACT_APP_API}/shipping/best-products`, {
    sort,
    order,
    page
  });

export const getProductsAdmin = async (sort, order, page) =>
  await axios.post(`${process.env.REACT_APP_API}/products-admin`, {
    sort,
    order,
    page,
  });

export const getProductBarcode = async (eanCode) =>
  await axios.post(
    `${process.env.REACT_APP_API}/product/scanner`,
    { eanCode }
  )

export const getProductsCount = async () =>
  await axios.get(`${process.env.REACT_APP_API}/products/total`);

export const productStar = async (productId, star, authtoken) =>
  await axios.put(
    `${process.env.REACT_APP_API}/product/star/${productId}`,
    { star },
    {
      headers: {
        authtoken,
      },
    }
  );

export const getRelated = async (productId) =>
  await axios.get(`${process.env.REACT_APP_API}/product/related/${productId}?store=${localStorage.getItem("storeNumber") ? localStorage.getItem("storeNumber") : 0}`);

export const fetchProductsByFilter = async (arg) =>
  await axios.post(`${process.env.REACT_APP_API}/search/filters`, arg);

  export const fetchProductsByFilterShop = async (arg, store) =>
  await axios.post(`${process.env.REACT_APP_API}/search/filters?store=${store}`, arg);

export const fetchProductsByStoreFilter = async (arg, store) =>
  await axios.post(`${process.env.REACT_APP_API}/search/store/filters`, { arg, store });

export const fetchProductsByTagFilter = async (arg, slug) =>
  await axios.post(`${process.env.REACT_APP_API}/search/tag-filter`, { arg, slug });

export const changeLimit = async () =>
  await axios.post(`${process.env.REACT_APP_API}/products/limit-change`);

export const updateCart = async (_id) => {
  await axios.post(`${process.env.REACT_APP_API}/update-cart`,
    { _id }
  )
}


export const getProductLogistic = async (store, product, start, end, authtoken) =>
  await axios.post(
    `${process.env.REACT_APP_API}/search/store-products/details`,
    { store, product, start, end },
    {
      headers: {
        authtoken,
      },
    }
  );

  export const duplicateProduct = async (data, token) =>
    await axios.post(`${process.env.REACT_APP_API}/product/duplicate`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    export const getAdminProductCampaigns = async () =>
      await axios.get(`${process.env.REACT_APP_API}/admin/product/get-campaigns`);